<script>
import {FormWizard, TabContent} from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'
export default {
  name: "WizardVue",
  components: {
    FormWizard,
    TabContent
  },
  data() {
    return {
      domain: "https://www.decofence.es",
      loading_resume: false,
      loading_status: "",
      loading_description: "",
      cat: null,
      models: [],
      model: {id: null},
      colors: [],
      color: {id: null},
      metodos: [],
      metodo: {id:null},
      params: [],
      tramos: [],
      continues: [],
      resume: {},
      categories: [
        {
          id: 37,
          name: "Sobre muro 100cm",
          url: "https://www.decofence.es/content/13-valla-sobre-muro-de-100cm-de-category",
          img: "https://www.decofence.es/assets/img/100cm.webp",
          short: "Sistema modular para montar sobre muro, en balcones o cercados. Su instalación es muy sencilla, ya que no se necesita realizar ninguna clase de soldadura, tan sólo montaje con tornillería y si lo prefieres con postes para atornillar o con postes para obrar. Disponemos de un accesorio de corte para ajustar el módulo de valla a la medida deseada de ancho.<br>Los módulos de valla miden 1950x945mm y están fabricados con chapa galvanizada de 1'5mm de espesor y con el mismo acabado lacado para toda la gama. Se suministra con toda la tornillería necesaria para su montaje.",
        },
        {
          id: 54,
          name: "Sobre muro 75cm",
          url: "https://www.decofence.es/content/14-valla-sobre-muro-de-75cm-de-category",
          img: "https://www.decofence.es/assets/img/75cm.webp",
          short: "Sistema modular de 1890x720mm para montar sobre muro en cerramientos exteriores. Su instalación es muy sencilla, no necesita realizar ninguna clase de soldaduras, solo montaje con tornillería y si lo prefieres con postes para atornillar o con postes para obrar.<br>Su sistema de montaje deja los tornillos ocultos, haciendo que su acabado sea elegante. Para ajustar un módulo a la medida deseada, disponemos de un accesorio de corte que permite cortar un módulo (a lo ancho) a la medida deseada y acoplarlo al poste sobre el que finaliza el montaje.",
        }
      ],
      info: '',
      urlCart: "https://www.decofence.es/crear-carrito",//?a=13-18&qa=2-1
      a: '',
      qa: '',
      p:'',
      qp: '',
      need_set_category: false,
    }
  },
  created(){
    let params = new URLSearchParams(window.location.search);
    this.cat = params.get('cat');
    if(this.cat === null || this.cat === undefined){
      this.need_set_category = true;
    } else {
      this.setCategory(parseInt(this.cat), true);
    }
  },
  methods:{
    async setCategory(categoryId, silent = false) {
      this.cat = parseInt(categoryId);
      switch (this.cat) {
        case 54: //75
          this.info = "<h2>VALLADO - Compuesto por 1 o más tramos.</h2><p>Los tramos pueden ser individuales o pueden estar enlazados entre sí, mediante un ángulo recto (90º), mediante un ángulo ajustable (desde 62º hasta 327º) o mediante un escalón.</p><p>Cuando tenemos un escalón, empezamos por el tramo inferior y por la parte contraria a dicho escalón.</p>";
          break;
        case 37: //100
          this.info = "<h2>VALLADO - Compuesto por 1 o más tramos.</h2><p>Los tramos pueden ser individuales o pueden estar enlazados entre sí, mediante un ángulo recto (90º), mediante un ángulo ajustable (desde 62º hasta 327º) o mediante un escalón.</p><p>Cuando tenemos un escalón, empezamos por el tramo inferior y por la parte contraria a dicho escalón.</p>";
          break;
      }
      this.getModels();
      if(silent === false) {
        await this.$swal({
          title: "¿Seguir con la selección del modelo?",
          icon: "question",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          showCancelButton: true,
          showCloseButton: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.$refs.formWizard.nextTab();
          }
        });
      }
    },
    getModels(){
      let url = `${this.domain}/rest/categoryProducts?id_category=${this.cat}&resultsPerPage=100&with_all_images=0&image_size=home_default`;
      this.axios.get(url)
          .then((response) => {
            for (let product of response.data.psdata.products){
              this.models.push({
                id: product.id_product,
                image: product.default_image.url,
                name: product.name,
                price: product.price,
                url: product.link
              })
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    async setModel(m){
      this.model = m;
      await this.$swal({
        title: "¿Seguir con la selección del color?",
        icon: "question",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showCancelButton: true,
        showCloseButton: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.getColors();
          this.$refs.formWizard.nextTab();
        }
      });
    },
    getColors(){
      this.colors = [];
      let url = `${this.domain}/rest/productdetail?product_id=${this.model.id}&image_type=large&with_all_images=0`;
      this.axios.get(url)
          .then((response) => {
            let colors = false;
            for (let [key, group] of Object.entries(response.data.psdata.groups)) {
              key;
              if (group.name === "Color") {
                colors = group.attributes;
              }
            }
            if(!colors){
              console.error("No hay combinación disponible")
              return false;
            }
            const images = response.data.psdata.images;
            const combinations = response.data.psdata.combinations;
            for (let combination of combinations) {
              let color = {
                id_combination: combination.combination_code,
                id_image: combination.image_id,
                image: '',
                name: '',
                color_hex: '',
              }
              const idCombination = combination.combination_code;
              const idImg = combination.image_id;
              if (idImg !== null) {
                color.name = colors[idCombination].name;
                color.color_hex = colors[idCombination].html_color_code.replace('#', '');
                color.image = images[idImg].src;
                this.colors.push(color);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    async setColor(c) {
      this.color = c;
      await this.$swal({
        title: "¿Seguir con la selección del método de instalación?",
        icon: "question",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showCancelButton: true,
        showCloseButton: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.getMetodos();
          this.$refs.formWizard.nextTab();
        }
      });
    },
    async getMetodos() {
      this.metodos = [];
      let atornillarId = null;
      let obrarId = null;
      switch (parseInt(this.cat)) {
        case 54: //75
          atornillarId = 51;
          obrarId = 57;
          break;
        case 37: //100
          atornillarId = 22;
          obrarId = 30;
          break;
      }
      await this.getProduct(atornillarId, 'Atornillar', 'atornillar');
      await this.getProduct(obrarId, 'Obrar', 'obrar');
    },
    async setMetodo(m) {
      this.metodo = m;
      await this.$swal({
        title: "¿Seguir con la configuración de tramos?",
        icon: "question",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showCancelButton: true,
        showCloseButton: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.getParams();
          this.addTramo(false)
          this.$refs.formWizard.nextTab();
        }
      });
    },
    getParams(){
      switch (parseInt(this.cat)){
        case 54://75
          if(this.metodo.metodo === 'atornillar'){
            this.params = {
              start: [
                {
                  id: 49,
                  title: "A pared (reversible)"
                },
                {
                  id: 51,
                  title: "Poste inicio izquierda"
                },
                {
                  id: 50,
                  title: "Poste inicio derecha"
                },
              ],
              continue: [
                {
                  id: 48,
                  title: "Poste ángulo ajustable"
                },
                {
                  id: 54,
                  title: "Poste ángulo 90º exterior"
                },
                {
                  id: 53,
                  title: "Poste ángulo 90º interior"
                },
              ],
              poste: {
                id: 52,
                title: "Poste de separación"
              },
              corte: {
                id: 61,
                title: "Accesorio de corte"
              }
            };
          }
          else {
            this.params = {
              start: [
                {
                  id: 57,
                  title: "Poste inicio izquierda"
                },
                {
                  id: 56,
                  title: "Poste inicio derecha"
                },
              ],
              continue: [
                 {
                  id: 55,
                  title: "Poste ángulo ajustable"
                },
                {
                  id: 60,
                  title: "Poste ángulo 90º exterior"
                },
                 {
                  id: 59,
                  title: "Poste ángulo 90º interior"
                },
              ],
              poste: {
                id: 58,
                title: "Poste de separación"
              },
              corte: {
                id: 61,
                title: "Accesorio de corte"
              },
            };
          }
          break;
        case 37: //100
          if(this.metodo.metodo === 'atornillar') {
            this.params = {
              start: [
                {
                  id: 316,
                  title: "A pared (reversible)"
                },
                {
                  id: 315,
                  title: "Poste inicio (reversible)"
                },
              ],
              continue: [
                {
                  id: 312,
                  title: "Poste ángulo ajustable"
                },
                {
                  id: 313,
                  title: "Poste ángulo 90º"
                },
                {
                  id: 314,
                  title: "Poste escalón"
                },
              ],
              poste: {
                id: 313,
                title: "Poste de separación"
              },
              corte: {
                id: 47,
                title: "Accesorio de corte"
              }
            };
          } else {
            this.params = {
              start: [
                {
                  id: 319,
                  title: "Poste inicio (reversible)"
                },
              ],
              continue: [
                {
                  id: 318,
                  title: "Poste escalón"
                },
              ],
              poste: {
                id: 319,
                title: "Poste de separación"
              },
              corte: {
                id: 47,
                title: "Accesorio de corte"
              }
            };
          }
          break;
      }
    },
    async addOrNO(kt) {
      let end = this.tramos[kt].end;
      if (this.params.continue.find((o) => parseInt(o.id) === parseInt(end)) !== undefined) {
        if ((kt + 1) === this.tramos.length) {
          this.addTramo(true);
        } else {
          this.tramos[kt + 1].continue = true;
        }
      } else if ((kt + 1) < this.tramos.length) {
        this.tramos[kt + 1].continue = false;
      } else {
        await this.$swal({
          title: "¿Ír al resumen?",
          icon: "question",
          confirmButtonText: "Ver resumen",
          cancelButtonText: "No, empezar un nuevo tramo",
          showCancelButton: true,
          showCloseButton: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.$refs.formWizard.nextTab();
            await this.getResume();
          } else {
            this.addTramo(false);
          }
        });
      }
    },
    addTramo(con){
      this.tramos.push({
        long: 0,
        start: null,
        end: null,
        continue: con,
        aprovechados: [],
      })
    },
    deleteTramo(kt){
      this.tramos.splice(kt, 1);
    },
    async getResume() {
      this.loading_resume = true;
      this.loading_status = "Calculando"
      this.loading_description = "Buscando complementos según el método de instalación."
      this.resume = {
        tramos: [],
        cortados: [],
        sobrantes: [],
        aprovechados: [],
        corte: 0,
        middle: 0,
        panel: parseInt(this.model.id),
        products: [],
        listProducts: [],
        total: 0,
      };
      let sep = 4;
      let minCorte = 20;
      let vLong, middle, corte;
      let minTramo;
      let tramos, products, cortes, middles, paneles, sobrantes, cortados;
      let aprovechados = [];
      let retProducts = [];
      let listProducts = [];
      let totalPrice = 0;
      switch (parseInt(this.cat)) {
        case 54://75
          vLong = 189;
          middle = (this.metodo.metodo === 'atornillar') ? 52 : 58;
          corte = 61;
          break;
        case 37://100
          vLong = 195;
          middle = (this.metodo.metodo === 'atornillar') ? 313 : 319;
          corte = 47;
          break;
      }
      minTramo = (sep * 2) + vLong;
      tramos = this.tramos;
      products = [];
      cortes = middles = paneles = 0;
      sobrantes = [];
      cortados = [];
      this.loading_description = "Contando los paneles necesarios, postes y accesorios de corte,"
      for (let k = 0; k < tramos.length; k++) {
        let tramo = tramos[k];
        tramos[k]['tramo'] = k;
        let long = parseInt(tramo['long']);
        let start = tramo['start'];
        let end = tramo['end'];
        tramos[k]['paneles'] = 0;
        tramos[k]['cortes'] = 0;
        tramos[k]['middles'] = 0;
        tramos[k]['division'] = false;
        let sepS = 0;
        if (start !== null) {
          if (typeof products.find(o => (o.productId === start)) !== "undefined") {
            products.find(o => (o.productId === start)).units++;
          } else {
            products.push({productId: start, units: 1, data: await this.getProduct(start, false, false)});
          }
          sepS = (start === 49 || start === 316)?0:sep
        }
        if (typeof products.find(o => (o.productId === end)) !== "undefined") {
          products.find(o => (o.productId === end)).units++;
        }
        else {
          products.push({productId: end, units: 1, data: await this.getProduct(end, false, false)});
        }
        let sepE = (end === 49 || end === 316)?0:sep
        minTramo = sepS+vLong+sepE;
        if (minTramo > long) {
          cortes++;
          paneles++;
          tramos[k]['paneles']++;
          tramos[k]['cortes']++;
          tramos[k]['middles'] = 0;
          let sobrante = minTramo - long;
          let cortado = vLong - sobrante;
          tramos[k]['cortado'] = cortado;
          tramos[k]['sobrante'] = sobrante;
          sobrantes.push({tramo: k, long: sobrante, used: false});
          cortados.push({tramo: k, long: cortado, used: false});
        }
        else if (minTramo === long) {
          paneles++;
        }
        else {
          let ip = Math.round(long / vLong);
          paneles += ip;
          tramos[k]['paneles'] += ip;
          middles += (ip - 1);
          tramos[k]['middles'] += (ip - 1);
          var calculated = sepS;
          calculated += ((ip*vLong)+((ip-1)*sep))+sepE;
          if (calculated > long) {
            let sobrante = calculated - long;
            let cortado = vLong - sobrante;
            if(cortado > minCorte) {
              tramos[k]['cortado'] = cortado;
              tramos[k]['sobrante'] = sobrante;
              sobrantes.push({tramo: k, long: sobrante, used: false});
              cortados.push({tramo: k, long: cortado, used: false});
              cortes++;
              tramos[k]['cortes']++;
            }
            else {
              let cortado2 = (cortado + vLong) / 2;
              let sobrante2 = vLong - cortado;
              cortes++;
              tramos[k]['cortes']++;
              tramos[k]['division'] = cortado;
              sobrantes.push({tramo: k, long: sobrante2, used: false});
              cortados.push({tramo: k, long: cortado2, used: false});
              sobrantes.push({tramo: k, long: sobrante2, used: false});
              cortados.push({tramo: k, long: cortado2, used: false});
            }
          }
          else if (calculated < long) {
            paneles++;
            tramos[k]['paneles']++;
            middles++;
            tramos[k]['middles']++;
            cortes++;
            tramos[k]['cortes']++;
            calculated += (sep + vLong);
            let sobrante = calculated - long;
            let cortado = vLong - sobrante;
            if(cortado > minCorte) {
              tramos[k]['cortado'] = cortado;
              tramos[k]['sobrante'] = sobrante;
              sobrantes.push({tramo: k, long: sobrante, used: false});
              cortados.push({tramo: k, long: cortado, used: false});
            } else {
              let cortado2 = (cortado + vLong) / 2;
              let sobrante2 = vLong - cortado2;
              cortes++;
              tramos[k]['cortes']++;
              tramos[k]['division'] = cortado;
              tramos[k]['cortado'] = cortado2;
              tramos[k]['sobrante'] = sobrante2;
              sobrantes.push({tramo: k, long: sobrante2, used: false});
              cortados.push({tramo: k, long: cortado2, used: false});
              sobrantes.push({tramo: k, long: sobrante2, used: false});
              cortados.push({tramo: k, long: cortado2, used: false});
            }
          }
        }
      }
      if(sobrantes.length > 0) {
        this.loading_description = "Revisar si hay algun sobrante que se pueda aprovechar y poder ahorrar algún panel";
        // Sort arrays
        cortados.sort((a, b) => a.long - b.long);
        sobrantes.sort((a, b) => a.long - b.long);
        for (let ks = 0; ks < sobrantes.length; ks++) {
          let sobrante = sobrantes[ks];
          if (sobrante['used'] === false) {
            for (let kc = 0; kc < cortados.length; kc++) {
              let cortado = cortados[kc];
              if (cortado['used'] === false && cortado['tramo'] !== sobrante['tramo'] && cortado['long'] <= sobrante['long']) {
                aprovechados.push({
                  tramo_origen: sobrante['tramo'],
                  tramo_destino: cortado['tramo'],
                  long: cortado['long'],
                  sobrante: sobrante['long'] - cortado['long']
                });
                tramos[cortado['tramo']]['aprovechados'].push({
                  tramo_origen: sobrante['tramo'],
                  tramo_destino: cortado['tramo'],
                  long: cortado['long'],
                  sobrante: sobrante['long'] - cortado['long']
                });
                paneles--;
                tramos[cortado['tramo']]['paneles']--;
                sobrantes.forEach((sobrante2, kss) => {
                  if (sobrante2['tramo'] === cortado['tramo'] && sobrantes[kss]['used'] === false) {
                    sobrantes[kss]['used'] = true;
                  }
                });
                cortados[kc]['used'] = true;
                sobrantes[kc]['used'] = true;
                break;
              }
            }
          }
        }
      }
      this.loading_description = "Calculando importes totales";
      if (typeof products.find(o => (o.productId === this.model.id)) !== "undefined") {
        products.find(o => (o.productId === this.model.id)).units += paneles;
      } else {
        products.push({productId: this.model.id, units: paneles, data: await this.getProduct(this.model.id, false, false)});
      }
      if (typeof products.find(o => (o.productId === middle)) !== "undefined") {
        products.find(o => (o.productId === middle)).units += middles;
      } else {
        products.push({productId: middle, units: middles, data: await this.getProduct(middle, false, false)});
      }
      if (typeof products.find(o => (o.productId === corte)) !== "undefined") {
        products.find(o => (o.productId === corte)).units += cortes;
      } else {
        products.push({productId: corte, units: cortes, data: await this.getProduct(corte, false, false)});
      }
      for (let product of products) {
        let colors = null;
        for (let kg in product.data.groups) {
          let group = product.data.groups[kg];
          if (group.name === "Color") {
            colors = group.attributes;
          }
        }
        let images = product.data.images;
        let combinations = product.data.combinations;
        let price = product.data.float_price;
        let total = price * product.units;
        let rePrice = false;
        let reTotal = false
        let discount = false;
        if (product.data.special_prices) {
          for (let specialPrice of product.data.special_prices) {
            if (specialPrice.from_quantity <= product.units) {
              if (specialPrice.percent) {
                rePrice = price / (1 + specialPrice.reduction);
                discount = (specialPrice.reduction * 100) + '%';
              } else {
                rePrice = price - specialPrice.reduction;
                discount = specialPrice.reduction + '€';
              }
            }
          }
          if (rePrice) {
            reTotal = rePrice * product.units;
          }
        }
        totalPrice += total;
        let rp = {
          id: parseInt(product.productId),
          units: parseInt(product.units),
          url: product.data.product_url,
          image: images[Object.keys(images)[0]].src,
          name: product.data.name,
          discount: (discount === false) ? false : parseFloat(discount),
          price: parseFloat(product.data.float_price),
          reduced_price: (rePrice === false) ? false : parseFloat(rePrice),
          total: parseFloat(total),
          reduced_total: (reTotal === false) ? false : parseFloat(reTotal),
          combination: null,
        };
        for (let combination of combinations) {
          let idCombination = combination.combination_code;
          let idImg = combination.image_id;
          if (idImg !== null && colors !== null && colors[idCombination].html_color_code.replace('#', '') === this.color.color_hex) {
            rp.image = images[idImg]['src'];
            rp.combination = combination.id_product_attribute;
          }
        }
        if(rp.units > 0) {
          if (rp.combination !== null) {
            this.a += (this.a === '') ? rp.combination : `-${rp.combination}`;
            this.qa += (this.qa === '') ? rp.units : `-${rp.units}`;
          } else {
            this.p += (this.p === '') ? rp.id : `-${rp.id}`;
            this.qp += (this.qp === '') ? rp.units : `-${rp.units}`;
          }
        }
        retProducts[`p-${rp.id}`] = rp;
        listProducts.push(rp);
      }
      this.resume = {
        tramos: tramos,
        cortados: cortados,
        sobrantes: sobrantes,
        aprovechados: aprovechados,
        corte: corte,
        middle: middle,
        panel: parseInt(this.model.id),
        products: retProducts,
        listProducts: listProducts,
        total: totalPrice,
      };
      this.loading_resume = false;
    },
    isValidTramos() {
      for(const tramo of this.tramos) {
        if(tramo.long === 0 || (tramo.start === null && !tramo.continue) || tramo.end === null){
          this.$swal({
            title: "Hay algún tramo incompleto",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: true,
          });
          return false;
        }
      }
      return true
    },
    isValidModel() {
      if(this.model.id === null){
        this.$swal({
          title: "Seleccione el modelo",
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: true,
        });
        return false;
      }
      return true;
    },
    isValidMetodo() {
      if(this.metodo.id === null) {
        this.$swal({
          title: "Seleccione el método de instalación",
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: true,
        });
        return false;
      }
      return true;
    },
    isValidColor() {
      if(this.color.id === null){
        this.$swal({
          title: "Seleccione el color",
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: true,
        });
        return false;
      }
      return true;
    },
    isValidCategory(){
      if(this.cat === undefined || this.cat === null){
        this.$swal({
          title: "Seleccione la altura deseada",
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: true,
        });
        return false;
      }
      return true;
    },
    async loadTab(pervIndex, nextIndex) {
      if (nextIndex > pervIndex) {
        switch (nextIndex) {
          case 1:
            if(!this.need_set_category){
              await this.getColors();
            }
            break;
          case 2:
            if(!this.need_set_category){
              await this.getMetodos();
            } else {
              await this.getColors();
            }
            break;
          case 3:
            if(!this.need_set_category){
              await this.getParams();
              this.tramos=[];
              this.addTramo(false);
            } else {
              await this.getMetodos();
            }
            break;
          case 4:
            if(!this.need_set_category){
              await this.getResume();
            } else {
              await this.getParams();
              this.tramos=[];
              this.addTramo(false);
            }
            break;
          case 5:
            if(!this.need_set_category){
              await this.getResume();
            }
            break;
        }
      }
    },
    async getProduct($productId, name, metodo){
      let url = `${this.domain}/rest/productdetail?product_id=${$productId}&image_type=large&with_all_images=0`;
      let product = {};
      await this.axios.get(url)
          .then((response) => {
            if(metodo !== false){
              let colors = false;
              for (let [key, group] of Object.entries(response.data.psdata.groups)) {
                key;
                if (group.name === "Color") {
                  colors = group.attributes;
                }
              }
              if(!colors){
                console.error("No hay combinación disponible")
                return false;
              }
              var images = response.data.psdata.images;
              var combinations = response.data.psdata.combinations;
              product = {
                'id': $productId,
                'image': images[Object.keys(images)[0]].src,
                'name': (!name)?response.data.psdata.name:name,
              };
              for (let combination of combinations) {
                var idCombination = combination.combination_code;
                var idImg = combination.image_id;
                if (idImg !== null && colors !== null && colors[idCombination].html_color_code.replace('#','') === this.color.color_hex) {
                  product.image = images[idImg].src;
                }
              }
              product.metodo = metodo
              this.metodos.push(product);
              return true;
            }
            product = response.data.psdata;
          })
          .catch((error) => {
            console.error(error);
          });
      return product;
    },
    setSubmit(){
      if(this.a === '' && this.p === ''){
        this.$swal({
          title: "No hay productos para añadir al carrito",
          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
        });
      }
      else {
        let urlTOCart = this.urlCart
        let sepQ = "?";
        if(this.p !== '') {
          urlTOCart += `${sepQ}p=${this.p}&qp=${this.qp}`;
          sepQ = "&";
        }
        if(this.a !== '') {
          urlTOCart += `${sepQ}a=${this.a}&qa=${this.qa}`;
        }
        window.open(urlTOCart, "_blank", 'noreferrer');
      }
    }
  }
}
</script>

<template>
  <v-app id="metalidea">
    <i class="fas fa-link"></i>
    <form-wizard
      ref="formWizard"
      title="Configura tu valla"
      shape="tab"
      back-button-text="< Anterior"
      next-button-text="Siguiente >"
      finish-button-text="Añadir al carrito"
      color="#d61f13"
      @on-complete="setSubmit"
      @on-change="loadTab"
    >
      <tab-content :before-change="isValidCategory" title="Altura" v-if="need_set_category">
        <div class="text-center container-fluid py-5">
          <div class="row">
            <div class="col-12 alert alert-info">
              <p class="mb-0"><b>Selección de la altura del vallado, una vez seleccionado pulsamos "SIGUIENTE".</b></p>
            </div>
          </div>
          <div class="row">
            <div  v-for="category in categories" :key="category.id" class="col-md-6 col-12 mb-4">
              <div class="card cardCategory mb-3" @click="setCategory(category.id)" :class="this.cat === category.id ? 'selected' : ''">
                <div class="card-body">
                  <h5 class="card-title text-dark">{{ category.name }}</h5>
                  <p class="card-text text-gray" v-html="category.short"/>
                </div>
                <a href="javascript:void(0)" v-on:click="setCategory(category.id)" class="linkProduct card-footer">Seleccionar altura</a>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content :before-change="isValidModel" title="Modelo">
        <div class="text-center container-fluid py-5">
          <div class="row">
            <div class="col-12 alert alert-info">
              <p class="mb-0"><b>Selección del modelo entre los diferentes diseños, una vez seleccionado pulsamos "SIGUIENTE".</b></p>
            </div>
          </div>
          <div class="row">
            <div v-for="(m, key) in models" :key="key" class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card cardModel" @click="setModel(m)" :class="(model.id === m.id) ? 'selected' : ''">
                <img :src="m.image" :alt="m.name" class="card-img-top" >
                <div class="card-body">
                  <h5 class="card-title text-dark">{{ m.name }}</h5>
                  <p class="card-text text-gray">{{ m.price }}</p>
                </div>
                <a href="javascript:void(0)" v-on:click="setModel(m)" rel="nofollow" class="linkProduct card-footer">Seleccionar el modelo</a>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content :before-change="isValidColor" title="Color" :lazy="true">
        <div class="text-center container-fluid py-5">
          <div class="row">
            <div class="col-12 alert alert-info">
              <p class="mb-0"><b>Disponemos de 7 acabados con su RAL correspondiente. El acabado óxido similar al acero corten y el gris forja es un gris oscuro con textura, similar al hierro antiguo. El acabado galvanizado no tiene ningún tratamiento de color, es solamente el acabado propio del galvanizado y cincado. Una vez seleccionado pulsamos "SIGUIENTE".</b></p>
            </div>
          </div>
          <div class="row">
            <div v-for="(c, key) in colors" :key="key" class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card" @click="setColor(c)" :class="(color.id_combination === c.id_combination) ? 'selected' : ''">
                <img :src="c.image" :alt="`Color ${c.name}`" class="card-img-top" >
                <div class="card-body">
                  <h5 class="card-title text-dark">{{c.name}}</h5>
                </div>
                <a href="javascript:void(0)" v-on:click="setColor(c)" rel="nofollow" class="linkProduct card-footer">Seleccionar el color</a>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content :before-change="isValidMetodo" title="Metodo" :lazy="true">
        <div class="text-center container-fluid py-5">
          <div class="row">
            <div class="col-12 alert alert-info">
              <p class="mb-0"><b>Poste para atornillar, dispone de una base de 12 x 12 cm para anclar al muro mediante tornillos. Poste para obrar, no tiene base inferior y es 20 cm más largo. Una vez seleccionado pulsamos "SIGUIENTE"."</b></p>
            </div>
          </div>
          <div class="row">
            <div v-for="(m, key) in metodos" :key="key" class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card" @click="setMetodo(m)" :class="(metodo.id === m.id) ? 'selected' : ''">
                <img :src="m.image" :alt="m.name" class="card-img-top" >
                <div class="card-body">
                  <h5 class="card-title text-dark">{{ m.name }}</h5>
                </div>
                <a href="javascript:void(0)" v-on:click="setMetodo(m)" rel="nofollow" class="linkProduct card-footer">Seleccionar el método</a>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content :before-change="isValidTramos" title="Tramos" :lazy="true">
        <div class="container-fluid py-5">
          <div class="row">
            <div class="col-12 alert alert-info" v-html="info"/>
          </div>
          <div class="row">
            <div class="col-12 mb-4">
              <h2>Visto siempre desde el exterior</h2>
            </div>
          </div>
          <div class="row" id="tramos">
            <div v-for="(tramo, kt) in tramos" :key="kt" class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card cardTramo">
                <div class="card-body">
                  <div class="row text-left">
                    <div class="form-group col-12 mb-2">
                      <label for="long" class="form-label">Longitud (cm)</label>
                      <input type="number" step="1" name="long" min="0" v-model="tramo.long" class="form-control">
                    </div>
                    <div  class="form-group col-12 mb-2" >
                      <label for="start" class="form-label">Anclaje de inicio</label>
                      <select name="start" class="form-control" v-model="tramo.start" v-if="!tramo.continue">
                        <option v-for="(param, kp) of params.start" :key="kp" :value="param.id">{{ param.title }}</option>
                      </select>
                      <input v-else type="text" class="form-control" disabled value="Continua">
                    </div>

                    <div  class="form-group col-12 mb-2">
                      <label for="end" class="form-label">Terminación o Continuación</label>
                      <select name="end" class="form-control" v-model="tramo.end" @change="addOrNO(kt)">
                        <optgroup label="Fin" v-if="params.start.length >0">
                          <option v-for="(param, kp) of params.start" :key="kp" :value="param.id">{{ param.title }}</option>
                        </optgroup>
                        <optgroup label="Continuar" v-if="params.continue.length >0">
                          <option v-for="(param, kp) of params.continue" :key="kp" :value="param.id">{{ param.title }}</option>
                        </optgroup>
                      </select>
                    </div>
                    <div class="col-12 mb-2">
                      <button type="button" class="btn btn-warning float-right" @click="deleteTramo(kt)" :disabled="kt === 0"><i class="fas fa-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card addTramo text-center" v-on:click="addTramo(false)">
                <div class="card-body">
                  <i class="far fa-times-circle rotate45"></i>
                  <p>Añadir tramo</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content title="Resumen" :lazy="true">
        <div class="container-fluid py-5" v-if="loading_resume">
          <div class="row text-center">
            <div class="col-md-6 col-sm-12 m-0-a">
              <div class="card ">
                <div class="card-header">
                  <h2><i class="fas fa-cog fa-spin text-metal"></i>&nbsp;{{ loading_status }}</h2>
                </div>
                <div class="card-body bg-white">
                  <p>{{ loading_description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid  py-5" v-else-if="resume.total !== undefined">
          <div class="row">
            <div class="col-12">
              <h2>Productos necesarios, por un importe de <span class="text-metal">{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(resume.total) }}</span></h2>
            </div>
          </div>
          <div class="row">
            <div v-for="product of resume.listProducts" :key="product.id" class="col-md-3 col-sm-6 col-12 mb-4">
              <div class="card">
                <span v-if="product.discount !== false" class="badge badge-info">-{{ product.discount}}</span>
                <img :src="product.image" :alt="product.name" class="card-img-top">
                <div class="card-body">
                  <a :href="product.url" target="_blank" rel="nofollow"><h5 class="card-title text-dark">{{ product.name }}</h5></a>
                  <p class="card-text text-gray" v-if="product.reduced_price === false">{{ product.units }} unidades, a <strong>{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.price) }}</strong></p>
                  <p class="card-text text-gray" v-else>{{ product.units }} unidades, a <small><del class="text-danger">{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.price) }}</del></small> <strong>{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.reduced_price) }}</strong></p>
                  <p class="card-text text-gray text-right" v-if="product.reduced_total === false"><strong>{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.total) }}</strong></p>
                  <p class="card-text text-gray text-right" v-else><small><del class="text-danger">{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.total) }}</del></small> <strong>{{ new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(product.reduced_total) }}</strong></p>
                </div>
                <a :href="product.url" target="_blank" rel="nofollow" class="linkProduct card-footer">Ver el producto</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h2>Instruccionés para la instalación</h2>
            </div>
            <div class="row instrucciones">
              <div class="col-12 mb-4" v-for="tramo in resume.tramos" :key="tramo.id">
                <div class="card">
                  <div class="card-header">
                    <h3>Tramo <strong>#{{ (tramo.tramo + 1) }}</strong>, {{ tramo.long }}cm</h3>
                  </div>
                  <div class="card-body bg-white">
                    <p v-if="tramo.paneles === 1">Un panel <a :href="resume.products[`p-${resume.panel}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.panel}`].name }}</a> <span v-if="tramo.cortado !== undefined">cortado a {{ tramo.cortado}}cm</span> <span v-if="tramo.division === false && tramo.aprovechados.length === 1">, puede aprovechar el sobrante del tramo <strong>#{{ (tramo.aprovechados[0].tramo_origen+1) }}</strong> para cortar los {{ tramo.cortado }}cm necesarios.</span></p>
                    <p v-else-if="tramo.paneles > 1">Paneles <a :href="resume.products[`p-${resume.panel}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.panel}`].name }}</a> necessarios: {{ tramo.paneles }}<span v-if="tramo.division === false && tramo.aprovechados.length === 1">, puede aprovechar el sobrante del tramo <strong>#{{ (tramo.aprovechados[0].tramo_origen+1) }}</strong> para cortar los {{ tramo.cortado }}cm necesarios.</span></p>
                    <p v-else-if="tramo.aprovechados.length === 1">No require de paneles <a :href="resume.products[`p-${resume.panel}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.panel}`].name }}</a> adicionales porqué puede aprovechar el sobrante del tramo <strong>#{{ (tramo.aprovechados[0].tramo_origen+1) }}</strong> para cortar los {{ tramo.cortado }}cm necesarios.</p>
                    <p v-if="tramo.division !== false">No és posible instalar un panel inferior a <i>20cm</i> por que el corte de <i>{{ tramo.division }}cm</i> no se puede montar, recomendamos cortar <b>2 paneles a {{ tramo.cortado }}cm</b>.</p>
                    <p v-if="tramo.start !== null">Iniciar con <a :href="resume.products[`p-${tramo.start}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${tramo.start}`].name }}</a>.</p>
                    <p v-if="tramo.middles > 0">Se require {{ tramo.middles }} de <a :href="resume.products[`p-${resume.middle}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.middle}`].name }}</a><span v-if="tramo.cortes > 0"> y {{ tramo.cortes }} <a :href="resume.products[`p-${resume.corte}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.corte}`].name }}</a></span>.</p>
                    <p v-if="tramo.middles === 0 && tramo.cortes > 0">Se require {{ tramo.cortes }} de <a :href="resume.products[`p-${resume.corte}`].url" target="_blank" rel="nofollow">{{ resume.products[`p-${resume.corte}`].name }}</a>.</p>
                    <p>Para terminar <a :href="resume.products[`p-${tramo.end}`]?.url" target="_blank" rel="nofollow">{{ resume.products[`p-${tramo.end}`].name }}</a>.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid py-5" v-else>
          <div class="row text-center">
            <div class="col-md-6 col-sm-12 m-0-a">
              <div class="card ">
                <div class="card-header">
                  <h2><i class="fas fa-exclamation text-metal"></i>&nbsp;Error al calcular el presupuesto</h2>
                </div>
                <div class="card-body bg-white">
                  <p>Puede notificarlo a <a href="mailto:comercial@decofence.es">comercial@decofence.es</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </v-app>
</template>

<style scoped>
.selected {border: 2px solid #d61f13 !important;}
.cardModel:hover, .cardMetodo:hover, .cardColor:hover{ cursor: hand;cursor: pointer;}
.card .card-body {background-color: #E6E6E6;border-bottom-left-radius: 6px;border-bottom-right-radius: 6px;}
.card .card-title {text-decoration: none;color: #5a5a5a}
.card .card-text {text-decoration: none;color: #808080}
.sw>.tab-content {height: fit-content!important;}
*{color: #1f140f}
.badge{position: absolute;background-color: rgb(214, 31, 19);right: 10px;top: 10px;font-size: 16px;}
.text-right{text-align: right}
a.linkProduct {background-color: rgb(214, 31, 19);color: #fff;text-align: center;border-top: none;}
.text-metal {color:  rgb(214, 31, 19);}
.tramoBtn { position:fixed; top:275px; right:20px;-ms-transform: rotate(90deg);-webkit-transform: rotate(90deg);transform: rotate(90deg);}
/deep/ .wizard-progress-with-circle {display: none !important;}
/deep/ .vue-form-wizard .wizard-icon-circle.tab_shape {display: none;}
/deep/ .vue-form-wizard .wizard-card-footer {position: fixed;bottom: 0;width: 100vw;background-color: #E6E6E6;padding: 0.5rem 2rem;border-top: 2px solid rgb(214, 31, 19);}
/deep/ .vue-form-wizard .wizard-nav-pills {    position: fixed;text-align: center;display: flex;flex-wrap: wrap;width: 100%;z-index: 6;background-color: #E6E6E6;top: 0;border-bottom: 2px solid rgb(214, 31, 19);padding-bottom: 0.5rem;}
/deep/ .vue-form-wizard .wizard-nav-pills>li>a {color: #aaa;}
/deep/ .py-5 {padding-top: 5rem!important;padding-bottom: 5rem!important;}
.m-0-a{margin: 0 auto;}
.instrucciones a{text-decoration: underline;}
.instrucciones a:hover{color: rgb(214, 31, 19);}
.instrucciones a::after{font-family: Font Awesome\ 5 Free;font-weight:900;content: "\f0c1";color: rgb(214, 31, 19);padding-left: 5px;}
.rotate45{-ms-transform: rotate(45deg);-webkit-transform: rotate(45deg);transform: rotate(45deg);}
.addTramo {height: 100%;text-align: center;}
.addTramo:hover{cursor: pointer;cursor: hand;}
.addTramo i{font-size: 5rem;margin-top: 3rem;color: rgba(214, 31, 19,.5);}
.addTramo p{margin: 0;margin-top: 3rem;color: rgba(214, 31, 19,.5);font-size: 1.5rem;font-weight: bold;}
</style>
